import { createStore, Store } from 'vuex';

import { state, RootStateI } from './state';
import mutations from './mutations';
import getters from './getters';

import toastStore from './toast';
import authStore from './auth';
import patientsStore from './patients';
import appointmentsStore from './appointments';

const store: Store<RootStateI> = createStore({
  state,
  mutations,
  getters,
});

store.registerModule('toast', toastStore);
store.registerModule('auth', authStore);
store.registerModule('patients', patientsStore);
store.registerModule('appointments', appointmentsStore);

export default store;
